export const BannerRoutes = [
  {
    key: 'UserChat',
    label: "Chat bo'limi",
  },
  {
    key: 'UserChatPeopleProfile',
    label: "Foydalanuvchi profili",
  },
  {
    key: 'UserChatNewChat',
    label: "Yangi chat",
  },
  {
    key: 'UserChatSearch',
    label: "Chat qidiruv",
  },
  {
    key: 'UserProfileAbout',
    label: "Profil haqida",
  },
  {
    key: 'UserProfileAppSetting',
    label: "Ilova sozlamalari",
  },
  {
    key: 'UserProfile',
    label: "Profil",
  },
  {
    key: 'UserProfileSettings',
    label: "Profil sozlamalari",
  },
  {
    key: 'UserTutorialsCertificate',
    label: "Sertifikatlar",
  },
  {
    key: 'UserTutorials',
    label: "Darsliklar",
  },
  {
    key: 'UserTutorialsSearch',
    label: "Darslik qidiruv",
  },
  {
    key: 'UserHome',
    label: "Bosh sahifa",
  },
  {
    key: 'UserNotification',
    label: "Bildirishnomalar",
  },
  {
    key: 'UserSpecTuto',
    label: "Maxsus darslik",
  },
  {
    key: 'UserMyLocation',
    label: "Mening joylashuvim",
  },
  {
    key: 'UserNews',
    label: "Yangiliklar",
  },
  {
    key: 'UserSos',
    label: "SOS",
  },
] as const;